module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Bottle#1-7427c80ff865f060ea161cc4ce74b84f.svg";